import { FormResponseType } from '../../../Services/Connection/types/FormResponseType';
import {
  CHECKBOX_TYPE,
  CHOICE_TYPE,
  EMAIL_TYPE,
  ENTITY_TYPE,
  HIDDEN_TYPE,
  PASSWORD_TYPE,
  TEL_TYPE,
  TEXT_TYPE,
} from './constants/inputTypes';
import { InputType } from './inputs/types/InputType';

export default class InputBuilder {
  private static inputEmail: (props: InputType) => HTMLElement;

  private static inputPassword: (props: InputType) => HTMLElement;

  private static inputCheckbox: (props: InputType) => HTMLElement;

  private static inputSelect: (props: InputType) => HTMLElement;

  private static inputHidden: (props: InputType) => HTMLElement;

  private static inputTel: (props: InputType) => HTMLElement;

  private static inputText: (props: InputType) => HTMLElement;

  public static getInput = async (
    key: string,
    inputInfos: FormResponseType['inputs'][0]
  ) => {
    const { type } = inputInfos;

    switch (type) {
      case EMAIL_TYPE: {
        if (!this.inputEmail) {
          const { default: InputEmail } = await import(
            /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-InputEmail' */ './inputs/InputEmail'
          );
          this.inputEmail = InputEmail;
        }

        return this.inputEmail({ name: key, ...inputInfos });
      }
      case PASSWORD_TYPE: {
        if (!this.inputPassword) {
          const { default: InputPassword } = await import(
            /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-InputPassword' */ './inputs/InputPassword'
          );
          this.inputPassword = InputPassword;
        }

        return this.inputPassword({ name: key, ...inputInfos });
      }
      case HIDDEN_TYPE: {
        if (!this.inputHidden) {
          const { default: InputHidden } = await import(
            /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-InputHidden' */ './inputs/InputHidden'
          );
          this.inputHidden = InputHidden;
        }

        return this.inputHidden({ name: key, ...inputInfos });
      }
      case CHECKBOX_TYPE: {
        if (!this.inputCheckbox) {
          const { default: InputCheckbox } = await import(
            /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-InputCheckbox' */ './inputs/InputCheckbox'
          );
          this.inputCheckbox = InputCheckbox;
        }

        return this.inputCheckbox({ name: key, ...inputInfos });
      }
      case CHOICE_TYPE:
      case ENTITY_TYPE: {
        if (!this.inputSelect) {
          const { default: InputSelect } = await import(
            /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-InputSelect' */ './inputs/InputSelect'
          );
          this.inputSelect = InputSelect;
        }

        return this.inputSelect({ name: key, ...inputInfos });
      }
      case TEL_TYPE: {
        if (!this.inputTel) {
          const { default: InputTel } = await import(
            /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-InputTel' */ './inputs/InputTel'
          );
          this.inputTel = InputTel;
        }

        return this.inputTel({ name: key, ...inputInfos });
      }
      case TEXT_TYPE:
      default: {
        if (!this.inputText) {
          const { default: InputText } = await import(
            /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-InputText' */ './inputs/InputText'
          );
          this.inputText = InputText;
        }

        return this.inputText({ name: key, ...inputInfos });
      }
    }
  };
}
